import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedNumber } from 'react-intl';

const DaysColumn = ({ value, className, ...rest }) => (
  <td
    className={classnames(
      'text-right days',
      {
        'text-muted': !value,
      },
      className,
    )}
    {...rest}
  >
    {!value && value !== 0 ? null : <FormattedNumber value={value} maximumFractionDigits={2} />}
  </td>
);
DaysColumn.propTypes = {
  value: PropTypes.number,
  className: PropTypes.string,
};
DaysColumn.defaultProps = {
  value: null,
  className: null,
};

export default DaysColumn;
